import { render } from "./SiteMapComponent.vue?vue&type=template&id=a6f1373c"
import script from "./SiteMapComponent.vue?vue&type=script&lang=js"
export * from "./SiteMapComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/twilkinson/Documents/DevProjects/AF3/af3-shortcodes-plugin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__